webpackJsonp([197553950038584],{

/***/ 1427:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"EmailTemplateInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"htmlTemplate","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-email-template-input-41ae3a971133b343ec9a.js